<template>
  <div>
          <base-header type="gradient-success" class="pb-6 pb-3 pt-5 pt-md-8">
            
          </base-header>
          <div class="card shadow"
            :class="type === 'dark' ? 'bg-default': ''">
            
            <div class="card-header border-0"
              :class="type === 'dark' ? 'bg-transparent': ''">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                    Tổ Chức
                  </h3>
                </div>
                
                <div class="col-md-3">
                  <atom-spinner
                  :animation-duration="1000" v-if="waiting"
                  :size="60"
                  :color="'#ff1d5e'"
                   />
       
                  <div class="form-group mb-0" v-else>
                    <base-input placeholder="Search"
                            class="input-group-alternative  mb-0"
                            alternative=""
                            addon-right-icon="fas fa-search" v-model="search">
                    </base-input>
                  </div>
       
                </div>
                <div class="col text-right">
                  <base-button type="primary"  v-if="permitl3" size="sm" onclick="window.location.href='/#/organizations/create'">Thêm</base-button>
                </div>
              </div>
            </div>
            
            <div class="table-responsive">
              <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  type="striped"
                  tbody-classes="list"
                  :data="rsorganizations">
                <template slot="columns">
                  <th>Tên</th>
                  <th>Phân Loại</th>
                  <th>Trạng Thái</th>
                  <th></th>
                </template>

                <template slot-scope="{row}">
                  <th scope="row" class="p-1">
                    <div class="media align-items-center">
                      <div class="media-body">
                        <router-link :to="{name:'detailorg', params:{orgid:row._id, orgname: row.name}}" class="btn name text-sm mb-0" append>{{row.name}}</router-link> 
                        
                      </div>
                    </div>
                  </th>
                  <td class="budget p-1" v-if="row.type==2">
                    Đối Tác
                  </td>
                  <td class="budget p-1" v-else-if="row.type==3">
                    KH/DT
                  </td>
                  <td class="budget p-1" v-else>
                    Khách Hàng
                  </td>
                  <td class="p-1">
                    <badge pill v-if="row.isactive" type="info">Active</badge>
                    <badge pill v-else type="danger">Disable</badge>
                  </td>
                  <td class="col-3 p-1 text-right">
                    <router-link :to="{name:'editorg', params:{orgid: row._id}}" v-if="permitl3"  class="btn btn-warning btn-sm" append>Sửa</router-link>
                    <base-button type="button" class="btn btn-danger btn-sm" v-if="isAdmin" @click="deleteOrg(row)">Xóa</base-button>
                  </td>
                </template>

              </base-table>
            </div>
          </div>
        </div>
</template>
<script>
import _ from "lodash"
import {AtomSpinner} from 'epic-spinners'
export default {
    name: 'projects-table',
    components:{
      AtomSpinner
    },
    props: {
      type: {
        type: String
      },
      title: String
    },
    data() {
      return {
        search: '',
        organizations: [],
        waiting: {
          type: Boolean,
          default: false
        },
      }
    },
    mounted() {
      this.fetchOrgs();
    },
    methods: {
      
      fetchOrgs() {
        this.waiting =true
        this.$http.get('/organizations').then((res) => {
          this.organizations = res.data
          this.waiting = false
        }).catch(()=> {})
      },
      deleteOrg(org) {
        let data = { orgid: org._id}
        this.organizations = _.without(this.organizations, org)
        this.$http.post('/organizations/delete',data)
      }
    },
    computed: {
      rsorganizations() {
        return this.organizations.filter(org => { return org.name.toLowerCase().includes(this.search.toLowerCase())})
      },
      permitl3() {
          return this.$store.getters.permit_l3
        },
      isAdmin() {
        return this.$store.getters.is_admin
      },
    }
}
</script>
<style >

</style>